import {
  CButton,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
} from "@coreui/react";
import CryptoJS from "crypto-js";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import authservice from "../services/auth.services";

const DeleteAccount = () => {
  // -------------- do not remove this commented code -----------------
  const navigate = useNavigate();
  const secretKey = process.env.REACT_APP_CRYPTJS_SECRET_KEY;
  // const id = "4";
  const [userId, setUserId] = useState(null);

  const [formData, setFormData] = useState({
    mobileNo: "",
    reason: "",
  });

  const [errors, setErrors] = useState({
    mobileNo: "",
    reason: "",
  });

  const [isValidated, setIsValidated] = useState(false);

  // ------------ input handler -----------------
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // ------------ validate mobile -----------------
  const verifyMobileNo = async () => {
    try {
      const url = "ValidateUserMobileNo";
      const jsonData = {
        mobileNumber: formData.mobileNo,
        userTypeId: Number(userId),
      };

      const response = await authservice.postJsonData(url, jsonData);

      if (response.apiResponseCode === "1001") {
        setIsValidated(true);
        setErrors({ mobileNo: "", reason: "" });
      } else {
        setIsValidated(false);
        setErrors((prev) => ({
          ...prev,
          mobileNo: response.apiResponseMsg || "Invalid mobile number.",
        }));
      }
    } catch (err) {
      console.warn("Delete Account Mobile Number Validation Error:", err);
      setErrors((prev) => ({
        ...prev,
        mobileNo: "Something went wrong. Try again later.",
      }));
    }
  };

  // ------------ mobile validation button handler -----------------
  const handleValidate = () => {
    if (formData.mobileNo.trim() === "" || formData.mobileNo.length !== 10) {
      setErrors((prev) => ({
        ...prev,
        mobileNo: "Please enter a valid 10-digit mobile number.",
      }));
      return;
    }
    verifyMobileNo();
  };

  // ------------ form submit -----------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.reason.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        reason: "Please enter valid reason.",
      }));
      return;
    }

    try {
      const url = "setAccountDeleteRequest";
      const jsonData = {
        mobileNumber: formData.mobileNo,
        userTypeId: Number(userId),
        reason: formData.reason,
      };

      const response = await authservice.postJsonData(url, jsonData);

      if (response.apiResponseCode === "1001") {
        Swal.fire({
          icon: "success",
          text: response.apiResponseMsg,
          confirmButtonText: "OK",
        });
        setFormData({ mobileNo: "", reason: "" });
        setIsValidated(false);
        setErrors({ mobileNo: "", reason: "" });
      } else {
        Swal.fire({
          icon: "error",
          text: response.apiResponseMsg,
          confirmButtonText: "OK",
        });
        setFormData({ mobileNo: "", reason: "" });
        setIsValidated(false);
        setErrors({ mobileNo: "", reason: "" });
      }
    } catch (err) {
      console.warn("Error in delete account form submit:", err);
      setErrors((prev) => ({
        ...prev,
        reason: "Something went wrong. Please try again later.",
      }));
    }
  };

  // -------------- do not remove this commented code -----------------
  // ------------ encrypt user id function -----------------
  // const encryptId = (idd) => {
  //   return CryptoJS.AES.encrypt(idd, secretKey).toString();
  // };

  // useEffect(() => {
  //   const encryptedId = encryptId(id);
  //   navigate(`/deleteUser?userId=${encodeURIComponent(encryptedId)}`);
  // }, []);

  // ------------ decrypt user id -----------------
  const decryptId = (encryptedId) => {
    const bytes = CryptoJS.AES.decrypt(encryptedId, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  // ------------ get user id on load -----------------
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedId = urlParams.get("userId");

    if (encryptedId) {
      const decryptedId = decryptId(decodeURIComponent(encryptedId));

      if (decryptedId) {
        setUserId(decryptedId);
      } else {
        navigate("/unauthorisedUser");
      }
    } else {
      navigate("/unauthorisedUser");
    }
  }, []);

  return (
    <div className="delete-account-parent-div account-page-height">
      <h2 className="mt-5">Account Deletion Request</h2>
      <div className="delete-account-sub-div">
        <h3 className="mb-4">
          If you wish to delete your account, please use the form below to
          submit a request. Once your request is processed, all data associated
          with your account will be permanently removed from our system in
          accordance with our data retention and privacy policies.
        </h3>

        <CForm className="delete-account-form" onSubmit={handleSubmit}>
          <div className="del-acc-form-subDiv">
            <div className="del-acc-form-inputDiv">
              <CFormLabel>Mobile Number</CFormLabel>
              <CFormInput
                type="tel"
                name="mobileNo"
                placeholder="Enter your mobile"
                value={formData.mobileNo}
                onChange={handleInput}
                minLength={10}
                maxLength={10}
                disabled={isValidated}
              />
              {errors.mobileNo && (
                <p
                  style={{ color: "red", fontSize: "13px", paddingLeft: "5px" }}
                >
                  {errors.mobileNo}
                </p>
              )}
            </div>

            {!isValidated && (
              <div className="del-acc-form-btns">
                <CButton type="button" onClick={handleValidate}>
                  Continue
                </CButton>
              </div>
            )}

            {isValidated && (
              <>
                <div className="del-acc-form-inputDiv">
                  <CFormLabel>Reason</CFormLabel>
                  <CFormTextarea
                    rows={3}
                    name="reason"
                    value={formData.reason}
                    onChange={handleInput}
                    minLength={10}
                    maxLength={500}
                    placeholder="Please specify your reason for deleting your account"
                  />
                  {errors.reason && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "13px",
                        paddingLeft: "5px",
                      }}
                    >
                      {errors.reason}
                    </p>
                  )}
                </div>

                <div className="del-acc-form-btns">
                  <CButton type="submit">Submit</CButton>
                </div>
              </>
            )}
          </div>
        </CForm>
      </div>
    </div>
  );
};

export default DeleteAccount;
